export default __webpack_public_path__ + "static/media/fixedold-before.0c68cee3.png";